import { render, staticRenderFns } from "./RankingsComponent.vue?vue&type=template&id=2e5d7bbc&scoped=true&"
import script from "./RankingsComponent.vue?vue&type=script&lang=js&"
export * from "./RankingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./RankingsComponent.vue?vue&type=style&index=0&id=2e5d7bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d7bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VFlex,VLayout,VSpacer})
